import { useEffect, useRef } from 'react';
import { useLazyGetLangQuery } from '../../../features/user/api/userApi';
import { detectClientLang, applyLanguage, LOCAL_STORAGE_LANG_KEY } from '../../utils/language';
import { getAccessToken } from '../../utils/authStorage';
import { useSelector } from 'react-redux';
import { selectAuthStatus } from '../../store/authSelectors';

let didInitLang = false;

const LanguageBootstrapper = () => {
    const [trigger] = useLazyGetLangQuery();
    const mountedRef = useRef(false);
    const syncedServerRef = useRef(false);
    const authStatus = useSelector(selectAuthStatus);

    useEffect(() => {
        if (mountedRef.current) return;
        mountedRef.current = true;

        if (didInitLang) return;
        didInitLang = true;

        try {
            const stored = localStorage.getItem(LOCAL_STORAGE_LANG_KEY);
            if (stored) {
                applyLanguage(stored);
                // We will still sync to server after auth (second effect)
                return;
            }
        } catch { }

        const current = detectClientLang();
        const token = getAccessToken();

        if (token) {
            trigger(current || undefined)
                .unwrap()
                .then((resp) => {
                    const lang = resp?.lang || current || 'ru';
                    applyLanguage(lang);
                    syncedServerRef.current = true;
                })
                .catch(() => {
                    applyLanguage(current || 'ru');
                });
        } else {
            applyLanguage(current || 'ru');
        }
    }, [trigger]);

    // After authentication succeeds, sync language to backend once if not yet synced
    useEffect(() => {
        if (syncedServerRef.current) return;
        if (authStatus !== 'succeeded') return;

        let stored = null;
        try { stored = localStorage.getItem(LOCAL_STORAGE_LANG_KEY); } catch { }
        const current = stored || detectClientLang() || 'ru';

        trigger(current)
            .unwrap()
            .then((resp) => {
                const lang = resp?.lang || current;
                applyLanguage(lang);
                syncedServerRef.current = true;
            })
            .catch(() => {
                // ignore errors; keep local setting
                syncedServerRef.current = true;
            });
    }, [authStatus, trigger]);

    return null;
};

export default LanguageBootstrapper;
